import { ReactElement } from 'react';
import classNames from 'classnames';

export interface NotificationPanelFilterWorkspace {
  name: string;
  imageUrl: string | null;
}

interface NotificationPanelFilterWorkspaceIconProps {
  workspace: NotificationPanelFilterWorkspace;
  size?: 'sm' | 'md';
  additionalClasses?: string;
}

export const NotificationPanelFilterWorkspaceIcon = (props: NotificationPanelFilterWorkspaceIconProps) => {
  const { workspace, size = 'md', additionalClasses } = props;
  if (!workspace) return;

  let icon: ReactElement | null = null;
  if (workspace.imageUrl) {
    icon = (
      <img
        src={workspace.imageUrl}
        alt={workspace.name}
        className={classNames('rounded', size === 'sm' ? 'size-4' : 'size-6', additionalClasses)}
      />
    );
  } else {
    icon = (
      <div
        className={classNames(
          'flex items-center justify-center rounded bg-cyan-900 text-white font-semibold uppercase shrink-0',
          size === 'sm' ? 'size-4 text-[8px] leading-[10px]' : 'size-6 text-[10px] leading-3',
          additionalClasses
        )}
      >
        {workspace.name.substring(0, 2)}
      </div>
    );
  }

  return icon;
};
